const OrderMenu = (state, action) => {
  if (!state) {
    return {
      menuKey: '0',
    }
  }

  switch (action.type) {
  case 'MENUKEY':
    return { ...state, menuKey: action.menuKey, menuIdx: action.menuIdx }
  case 'MENUURL':
    return { ...state, menuUrl: action.menuUrl }
  default:
    return state
  }
}

export default OrderMenu


// WEBPACK FOOTER //
// ./src/reducer/order-menu.js